import type { GlobalState } from '#reducers/state';
import type { MemberFilters } from '#utils/memberUtils';

/** Stable key for members pagination in Redux (by filter query string, or `'all'`). */
export function membersListKey(filter?: MemberFilters) {
  return filter ? filter.toFrontendMembersQueryString() : 'all';
}

export const membersPaginationByKeySelector = (key: string) => (state: GlobalState) =>
  state.members.pagination.get(key);
